import React from 'react';
import config from './data/config.json';

const Testimonials = () => {
  return (
    <section
      className="py-5 bg-light"
      style={{
        backgroundImage: `url('./images/testimonials.webp')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        zIndex: 1,
      }}
    >
      <div className="overlay"></div>
      <div className="container" style={{ zIndex: 2000000, position: 'relative' }}>
        <h2 className="text-center mb-5 text-white">What Our Clients Say</h2>
        <div className="row">
          {config.testimonials.map((testimonial, index) => (
            <div key={index} className="col-md-4 mb-4">
              <div className="p-4 h-100 shadow rounded bg-white">
                <div className="mb-3 text-muted">
                  <i className="bi bi-quote" style={{ fontSize: '2rem' }}></i>
                </div>
                <p className="fst-italic">"{testimonial.description}"</p>
                <p className="fw-bold mb-0 mt-3">— {testimonial.name}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
